import { Host, h } from "@stencil/core";
export class DnnModal {
    constructor() {
        /**
         * Pass true to remove the backdrop click auto-dismiss feature.
         * Defaults to false.
         */
        this.preventBackdropDismiss = false;
        /**
         * Optionally pass the aria-label text for the close button.
         * Defaults to "Close modal" if not provided.
         */
        this.closeText = "Close modal";
        /**
         * If set to true, the modal becomes resizable.
         */
        this.resizable = false;
        /**
         * Optionally you can pass true to not show the close button.
         * If you decide to do so, you should either not also prevent dismissal by clicking the backdrop
         * or provide your own dismissal logic in the modal content.
         */
        this.hideCloseButton = false;
        /**
         * Reflects the visible state of the modal.
         */
        this.visible = false;
        this.mouseX = 0;
        this.mouseY = 0;
        this.w = 0;
        this.h = 0;
        // FOR RESIZING
        this.handleResizeMouseMove = (ev) => {
            // deviding by two because the modal is centered. 
            const dx = (ev.clientX - this.mouseX) * 2;
            const dy = (ev.clientY - this.mouseY) * 2;
            this.modal.style.width = `${this.w + dx}px`;
            this.modal.style.height = `${this.h + dy}px`;
        };
        this.handleResizeMouseDown = (ev) => {
            addEventListener("mousemove", this.handleResizeMouseMove);
            this.mouseX = ev.clientX;
            this.mouseY = ev.clientY;
            const modalStyles = getComputedStyle(this.modal);
            this.w = parseInt(modalStyles.width, 10);
            this.h = parseInt(modalStyles.height, 10);
        };
        this.handleResizeMouseUp = () => {
            removeEventListener("mousemove", this.handleResizeMouseMove);
        };
    }
    /**
     * Shows the modal
    */
    async show() {
        this.visible = true;
    }
    /**
     * Hides the modal
    */
    async hide() {
        this.visible = false;
    }
    componentWillLoad() {
        if (this.backdropDismiss != undefined) {
            console.warn("The 'backdropDismiss' prop is deprecated. Use 'preventBackdropDismiss' instead.");
            this.preventBackdropDismiss = !this.backdropDismiss;
        }
        if (this.showCloseButton != undefined) {
            console.warn("The 'showCloseButton' prop is deprecated. Use 'hideCloseButton' instead.");
            this.hideCloseButton = !this.showCloseButton;
        }
    }
    componentDidLoad() {
        var _a;
        (_a = this.seDrag) === null || _a === void 0 ? void 0 : _a.addEventListener("mousedown", this.handleResizeMouseDown);
        addEventListener("mouseup", this.handleResizeMouseUp);
    }
    disconnectedCallback() {
        var _a;
        (_a = this.seDrag) === null || _a === void 0 ? void 0 : _a.removeEventListener("mousedown", this.handleResizeMouseDown);
        removeEventListener("mouseup", this.handleResizeMouseUp);
    }
    handleDismiss() {
        this.visible = false;
        this.dismissed.emit();
    }
    // FOR BACKDROP CLICK
    handleBackdropClick(e) {
        const element = e.target;
        if (element.id === "backdrop" && !this.preventBackdropDismiss) {
            this.handleDismiss();
        }
    }
    render() {
        return (h(Host, { key: '1b553793159147c3bcbefe3feb0040dca184f279' }, h("div", { key: '83d338885e97f2f5aae58826a503f0ef9acc129e', id: "backdrop", class: this.visible ? 'overlay visible' : 'overlay', onClick: e => this.handleBackdropClick(e) }, h("div", { key: '22b9240c98a27046d7f1a1105c11c97f8f22a3c7', class: "modal", ref: el => this.modal = el }, !this.hideCloseButton &&
            h("button", { key: '291c1da4d7a6036fdc74160e9542f6c88ec91cdd', class: "close", "aria-label": this.closeText, onClick: () => this.handleDismiss() }, h("svg", { key: '6b42864cda915b5b2f9c0c3b31a12916f1329bdc', xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 0 24 24", width: "24px", fill: "#000000" }, h("path", { key: '8647863fb4e6eecfe0fde4b869fdf2f19613c34d', d: "M0 0h24v24H0z", fill: "none" }), h("path", { key: 'ba4210c8aec3728f25e71e173d14935ac2687343', d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" }))), h("div", { key: '6111d4069b7975f9b752c3640d357e933a444332', class: "content" }, h("slot", { key: '82288c865bacb35b26a696f0d4e1e85c925e0aed' })), this.resizable && h("div", { key: 'bf144ef24308dfadd8a11182f080759c0ef1c860', class: 'se', ref: el => this.seDrag = el })))));
    }
    static get is() { return "dnn-modal"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["dnn-modal.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dnn-modal.css"]
        };
    }
    static get properties() {
        return {
            "backdropDismiss": {
                "type": "boolean",
                "attribute": "backdrop-dismiss",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [{
                            "name": "deprecated",
                            "text": "boolean props should always default to being false per html specs, use preventBackdropDismiss instead, will be removed in v0.28.0.\nPass false to remove the backdrop click auto-dismiss feature."
                        }],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false
            },
            "preventBackdropDismiss": {
                "type": "boolean",
                "attribute": "prevent-backdrop-dismiss",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Pass true to remove the backdrop click auto-dismiss feature.\nDefaults to false."
                },
                "getter": false,
                "setter": false,
                "reflect": true,
                "defaultValue": "false"
            },
            "closeText": {
                "type": "string",
                "attribute": "close-text",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Optionally pass the aria-label text for the close button.\nDefaults to \"Close modal\" if not provided."
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "\"Close modal\""
            },
            "resizable": {
                "type": "boolean",
                "attribute": "resizable",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "If set to true, the modal becomes resizable."
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            },
            "showCloseButton": {
                "type": "boolean",
                "attribute": "show-close-button",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [{
                            "name": "deprecated",
                            "text": "boolean props should always default to being false per html specs, use hideCloseButton instead, will be removed in v0.28.0.\nOptionally you can pass false to not show the close button.\nIf you decide to do so, you should either not also prevent dismissal by clicking the backdrop\nor provide your own dismissal logic in the modal content."
                        }],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false
            },
            "hideCloseButton": {
                "type": "boolean",
                "attribute": "hide-close-button",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Optionally you can pass true to not show the close button.\nIf you decide to do so, you should either not also prevent dismissal by clicking the backdrop\nor provide your own dismissal logic in the modal content."
                },
                "getter": false,
                "setter": false,
                "reflect": true,
                "defaultValue": "false"
            },
            "visible": {
                "type": "boolean",
                "attribute": "visible",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Reflects the visible state of the modal."
                },
                "getter": false,
                "setter": false,
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "dismissed",
                "name": "dismissed",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fires when the modal is dismissed."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get methods() {
        return {
            "show": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "Shows the modal",
                    "tags": []
                }
            },
            "hide": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "Hides the modal",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=dnn-modal.js.map
